import { Fragment, useCallback, useState } from 'react';

import AlertComponent from 'components/alert';
import RenderIf from 'components/RenderIf';
import CustomProgress from 'modules/auth/components/CustomProgress';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import CustomPagination from '../components/CustomPagination';
import { PlayCirculation } from '../components/PlayCirculation';
import useCirculation from '../hooks/useCirculation';
import BarcodeModal from '../modals/Barcode';
import '../styles/style.css';

export default function PlayList() {
  const { number } = useParams();
  const { t } = useTranslation();

  const { data, loading, setSkip, take, totalCount } = useCirculation();

  const [showBarcode, setShowBarcode] = useState(false);
  const [ticketInformation, setTicketInformation] = useState({});

  const onCreateVoidTicket = useCallback((ticketInformation) => {
    setTicketInformation(ticketInformation);
    setShowBarcode(true);
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>{t('BRON')} | 1x2</title>
        <meta name="description" content={`${t('BRON')} | 1x2`} />
      </Helmet>
      <div className="play-list bg-gray py-4">
        <div className="container play-list-container">
          {data?.length ? (
            <PlayCirculation
              circulations={data}
              onCreateVoidTicket={onCreateVoidTicket}
            />
          ) : !data.length && !loading ? (
            <AlertComponent
              variant="info"
              message={t('NO_ACTIVE_CIRCULATION')}
            />
          ) : (
            ''
          )}
          {loading && (
            <div className="custom-progress">
              <CustomProgress />
            </div>
          )}

          {totalCount > 6 ? (
            <CustomPagination
              totalCount={totalCount}
              setSkip={setSkip}
              take={take}
              number={number}
              url={'/'}
            />
          ) : (
            ''
          )}
        </div>
      </div>
      <RenderIf condition={showBarcode}>
        <BarcodeModal
          show={showBarcode}
          onHide={setShowBarcode}
          ticketInformation={ticketInformation}
          url="voidTickets"
          enablePrint
        />
      </RenderIf>
    </Fragment>
  );
}
